import React from 'react';

// These files are created by production.sh during build from
//   ~/src/ntdl-2/new_records_mapping.txt
// which must be the identical file used by the TS harvester.
// This is the order in which the metadata fields should be displayed:
const new_records_mapping_order = require('./new_records_mapping.js');
// This is the reverse lookup from metadata dc. names to text names:
const new_records_mapping_lookup = require('./new_records_lookup.js');

// Preliminary text for download buttons.
const preText = (isMobileBrowser()) ? "" : "Download as ";

// A function to convert numeric month to month name
const monthText = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

// A function to truncate month names for MLA
export function mlaMonth(M) {
  let abbr = {
    "January"   : "Jan",
    "February"  : "Feb",
    "March"     : "Mar",
    "April"     : "Apr",
    "May"       : "May",
    "June"      : "June",
    "July"      : "July",
    "August"    : "Aug",
    "September" : "Sept",
    "October"   : "Oct",
    "November"  : "Nov",
    "December"  : "Dec"
  }
  if (abbr.hasOwnProperty(M)) {
    //console.log(`mlaMonth() returning ${abbr[M]}`);
    return abbr[M];
  } else {
    return M;
  }
}

// NTDL-756 - Copyright Behaviour
var CopyrightBehaviourGrid;
var COPYRIGHT_JSON_TEXT = (
  (typeof window !== 'undefined' && window.document && window.document.createElement ) ? (
    window.copyright_json_text
  ) : (
    process.env.copyright_json_text
  )
);

if (COPYRIGHT_JSON_TEXT) {
  CopyrightBehaviourGrid = JSON.parse(COPYRIGHT_JSON_TEXT);
  //console.log('Using CopyrightBehaviourGrid from DB');
} else {
  //CopyrightBehaviourGrid = require('./copyright_behaviours.js');
  CopyrightBehaviourGrid = React.lazy(() => import('././copyright_behaviours.js'));
  console.log('Warning: Using CopyrightBehaviourGrid from JS file');
}
// NTDL-756 - Copyright Behaviour

// Check if two numbers are "near" enough to each other
// Used to check for a click, between mouseDown and mouseUp coords
export function nearEnough(a, b, dist) {
    if (a === b) {
        return true;
    } else {
        // Check if the two numbers are within dist of each other
        // |--smallest---->|--dist-->|
        // |--largest---------->|
        let largest = (a > b) ? a : b ;
        let smallest = (a < b) ? a : b ;
        if (( smallest <= largest ) && (largest <= (smallest + dist))) {
            return true;
        } else {
            return false;
        }
    }
}

export function debounce(callback, context = this, wait = 100) {
  let timeout = null
  let callbackArgs = null

  const later = () => callback.apply(context, callbackArgs)

  return function() {
    callbackArgs = arguments
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

// Extract a string from a "string coded" list:
//   "['This is some text.']" -> "This is some text."
// Note, if the list is really a list, this creates issues:
//   "['one', 'two', 'three']" -> "one', 'two', 'three"
//   "['item with, a comma', 'two', 'three']" -> "a big string, with commas', 'two', 'three"
export function extractString(str){
  // This is not straightforward, but should strip the text
  // out of array-like strings returned from Elasticsearch
  // Would probably be best to just expect array data...?
  if ((str != undefined) && (str != null) && (str != '')) {
    let re = /^\[['"\\]+(.*)['"\\]+\]$/;
    return str.replace(re, '$1').replace('"','');
  }
}

// NTDL-857 - Extract the first string from a "string coded" list:
//   "['one', 'two', 'three']" -> "one"
//   "['item with, a comma', 'two', 'three']" -> "item with, a comma"
export function extractStringOne(str){
  // This is not straightforward, but should strip the text
  // out of array-like strings returned from Elasticsearch
  // Would probably be best to just expect array data...?
  if ((str != undefined) && (str != null) && (str != '')) {
    let re = /^\[['"\\]+(.*)['"\\]+\]$/;
    return str.replace(re, '$1').replace('"','').split(/',\s?'/g)[0];
  }
}

// Because fullMetaObject could contain values which are arrays,
// this function returns either the first element of an array, or
// the plain value of the requested field.
export function getValueFromFullMetaObject(fullMetaObject,key) {
  let value = null;
  if (fullMetaObject.hasOwnProperty(key)) {
    if (Array.isArray(fullMetaObject[key])) {
      value = fullMetaObject[key][0];
    } else {
      value = fullMetaObject[key];
    }
  }
  return value;
}

export function createSwitchKeySearchBox(key) {
  var inputName;
  switch(key) {
    case "language":
      inputName = "Language";
      break;
    case "language_austlang":
      inputName = "Language Austlang";
      break;
    case "location":
      inputName = "Location";
      break;
    case "subject":
      inputName = "Subject";
      break;
    case "contributor":
      inputName = "Contributor";
      break;
    case "collection":
      inputName = "Collection";
      break;
    case "ntdl_type":
      inputName = "Type";
      break;
    default:
      inputName = "Default";
      break;
  }
  return inputName;
}

export function getKeyText(key) {
  var inputName;
  switch(key) {
    case "language":
      inputName = "language";
      break;
    case "language_austlang":
      inputName = "language_austlang";
      break;
    case "subject":
      inputName = "subject";
      break;
    case "collection_list":
      inputName = "collections";
      break;
    case "ntdl_type":
      inputName = "type";
      break;
    default:
      inputName = key;
      break;
  }
  return inputName;
}

export function getThumbnail(LOCAL_URL_PREFIX, thumbnail,i, ntdl_type, source) {
  if (thumbnail) {
    // If the thumbnail is just a path, add the prefix
    if (!(/^https?:\/\//i.test(thumbnail))) {
      //console.log("get Thumbnail  - if thumbnail - true - ",thumbnail);
      //thumbnail = `${LOCAL_URL_PREFIX}/${thumbnail}`;
      //thumbnail = url.resolve(LOCAL_URL_PREFIX,thumbnail);
      thumbnail = LOCAL_URL_PREFIX.replace(/\/+$/, '') + '/' + thumbnail.replace(/^\/+/, '');
      //console.log('Updated thumbnail = ' + thumbnail);
    }
  } else {
    /*
    var  tempstr = getTypeImage(ntdl_type);
    console.log('getThumbnail - else - generic',"ntdl -type : - ",ntdl_type);
    //thumbnail = `${LOCAL_URL_PREFIX}/generic/` + tempstr;
    thumbnail = LOCAL_URL_PREFIX + "/generic/" + tempstr;
    */
    /*
    var tempstr = getTypeBackgroundImage(ntdl_type, source);
    console.log("ntdl_type :-", ntdl_type, "source - ",source);
    thumbnail = LOCAL_URL_PREFIX + "/thumbnails/" + tempstr;
    */
  }
  return thumbnail;
}

// Try to extract a date in ISO format from a string.
// Allowing undefined or null for dateType fixes an ussue with only
// having the year displayed on results display tiles.
export function extractDate(date, dateType) {
  //console.log(`extractDate() date = ${date}, dateType = ${dateType}`);
  // dateType/date_type: 0 = year only, 1 = date, 2 = date & time
  if (dateType === undefined || dateType === null || dateType === 1 || dateType === 2) {
    // date = '2021-04-30T00:00:00.000Z'
    // day & month have leading zeroes here
    let match = date.match(/^([0-9]{4})-?([0-9]{2})?-?([0-9]{2})?/);
    if (match) {
      const month = (match[2]) ? monthText[+match[2]-1] : null;
      const shortMonth = (month) ? mlaMonth(month) : null;
      if ((match[1]) && (match[2] && match[2] != '00') && (match[3] && match[3] != '00')) {
        // Return full date object
        return {
          year: match[1],
          month: match[2],
          day: match[3],
          monthText: month,
          shortMonthText: shortMonth
        };
      } else if ((match[1]) && (match[2] && match[2] != '00')) {
        // Future support for YYYY-MM dates
        return {
          year: match[1],
          month: match[2],
          monthText: month,
          shortMonthText: shortMonth
        };
      } else if (match[1]) {
        return {
          year: match[1]
        };
      } else {
        console.log(`ERROR: extractDate(${date},${dateType}) Got match, found nothing`);
        return {};
      }
    } else {
      // May not reach here
      // Try to match a year anywhere (in case of undefined or null)
      let match = date.match(/([0-9]{4})/);
      if (match) {
        console.log(`WARNING: Matched year only in full date ${date}`);
        return {
          year: match[1]
        };
      } else {
        console.log(`ERROR: extractDate(${date},${dateType}) No match, found nothing`);
      }
    }
  } else {
    // Match year-only dates
    if (date && date.length >= 4) {
      let match = date.match(/^([0-9]{4})/);
      if (match) {
        return {
          year: match[1]
        };
      }
    }
  }
  // Shouldn't get to here, but log the date just in case.
  console.log(`ERROR: extractDate(${date},${dateType}) Unknown error`);
  return {};
}

// Returns date range, or end date in DD/MM/YYYY format.
// Used in reference.jsx and results.jsx to display date.
export function fixDateRange(start, end, dateType) {
  //console.log(`fixDateRange(${start},${end},${dateType})`);
  if (!end) {
    return;
  }
  if (start && start !== end) {
    return `${fixDate(start, dateType)}-${fixDate(end, dateType)}`;
  }
  return fixDate(end, dateType);
}

// Returns DD/MM/YYYY date from ISO date type.
export function fixDate(date, dateType) {
  //console.log(`fixDate(${date},${dateType})`);
  // Reject invalid dates
  if (date && date.includes("0000")) {
    return "Unspecified";
  }
  const realDate = extractDate(date, dateType);
  if (realDate.day) {
    return `${realDate.day}/${realDate.month}/${realDate.year}`;
  }
  return realDate.year;
}

// Returns an object for the current date
export function extractCurrentDate(date) {
  //console.log(`extractCurrentDate(${date})`);
  if (!date) {
    date = new Date();
  }
  const month = monthText[date.getMonth()];
  const shortMonth = mlaMonth(month);
  // Ensure day & month have leading zeroes
  return {
    year: date.getFullYear(),
    month: String(date.getMonth()+1).padStart(2,'0'),
    day: String(date.getDate()).padStart(2,'0'),
    monthText: month,
    shortMonthText: shortMonth
  };
}

export function query_string_to_dictionary(query) {
  query = query.replace(/#.*$/, '');
  query = query.replace(/^\?/, '');
  const key_values = {};
  for (let i of query.split('&')) {
    let [key, value] = i.split('=');
    if (value === undefined) {
      continue;
    }

    let keyValue = key_values[decodeURIComponent(key)];
    if (keyValue === undefined) {
      keyValue = [];
    }
    keyValue.push(decodeURIComponent(value.replace(/\+/g, ' ')));

    key_values[decodeURIComponent(key)] = keyValue;
  }

  return key_values;
}

export function dictionary_to_query_string(dict) {
  let result = '';
  for (let key in dict) {
    let values = dict[key];
    if (values === undefined) {
      continue;
    }

    if (!(values instanceof Array)) {
      values = [values];
    }

    if (values.length === 0) {
      continue;
    }

    for (let value of values) {
      result += result === '' ? '?' : '&';
      result += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }
  }
  return result;
}


export function checkAccessRights(record) {

  // Returns:
  // -1 - Show download button - Allow download, no known reason.
  //  0 - Show download button - Allow download, reason is known.
  //  1 - Shows Contact LANT Popup

  // If there's no download, this will be sorted out later on,
  // just return -1 unknown for now.
  if (record.link == null || record.link == undefined) {
    //console.log(`common.js record.link is null or undefined`);
    return -1;
  }

  // Check if we have a rights code, if not, allow the download:
  // - Metadata is inconsistent, and this could be specified in
  //   - record.dcterms_accessrights        = Human Readable
  //   - record.dcterms_accessrights_code   = Machine Readable
  //   But, we only worry about the Machine Readable field

  // So, get a string of existing rights
  var accessRights = '';
  //if (record.hasOwnProperty('dcterms_accessrights')) {
  //  console.log(`dcterms_accessrights = ${record.dcterms_accessrights}`);
  //  accessRights = (accessRights == '') ? accessRights : accessRights + ', ';
  //  accessRights += extractString(record.dcterms_accessrights);
  //}
  if (record.hasOwnProperty('dcterms_accessrights_code')) {
    //console.log(`dcterms_accessrights_code = ${record.dcterms_accessrights_code}`);
    accessRights = (accessRights == '') ? accessRights : accessRights + ', ';
    accessRights += extractString(record.dcterms_accessrights_code);
  }

  // Check if it is empty (return -1) and if not, trim it and continue.
  if (accessRights == '') {
    //console.log(`dcterms_accessrights_code null or empty`);
    return -1;
  } else {
    accessRights = accessRights.trim();
  }

  // Debug - perhaps it contains multiple restrictions
  //console.log(`accessRights = ${accessRights}`);

  // Here are the possible values (could also be case-variations):
  //accessRights = "Unrestricted Online Access";
  //accessRights = "Download Restriction";
  //accessRights = "Download Restriction until 2019-09-01";
  //accessRights = "Download Restriction until 2019-10-30";
  //accessRights = "Onsite access restriction";
  //accessRights = "Onsite access until 2019-01-01";
  //accessRights = "Onsite access until 2019-10-30";
  //accessRights = "Onsite access restriction at ANL:NED";
  //accessRights = "No Online Access";
  //accessRights = "View only under StoryNT Agreement";

  // Set everything to lower case from now on, since
  // humans enter this data.
  accessRights = accessRights.toLowerCase();

  // First process the fully restricted or unrestricted items:
  if (accessRights == "unrestricted online access") {
    // Display Download Button
    return 0;
  } else if ((accessRights == "download restriction") || (accessRights == "onsite access restriction")) {
    // Contact LANT
    return 1;
  } else if ((accessRights == "onsite access restriction at anl:ned") || (accessRights == "no online access")) {
    // Contact LANT
    return 1;
  }

  // Now process any date restrictions:
   var today = new Date();

   var nPos, restrictionDate;

   if ( accessRights.startsWith("download restriction until") == true) {
       nPos = accessRights.indexOf("until");

       nPos = nPos + 5;
       var date = accessRights.substr(nPos);
       date = date.trim();

       if (isDate(date) == true) {
           restrictionDate = new Date(date);
           var year = date.substring(0,4)
           var month= date.substring(5,7);
           var day =  date.slice(-2);
           restrictionDate = new Date(parseInt(year),parseInt(month)-1,parseInt(day));
       }
       else {
           return -1;
       }

       if (today.getTime() > restrictionDate.getTime()) {
           return 0;
       } else {
           return 1;
       }

   } else if(accessRights.startsWith("onsite access until") == true) {
       nPos = accessRights.indexOf("until");
       nPos = nPos + 5;
       var date = accessRights.substr(nPos);
       date.trim()
       if (isDate(date) == true) {
          restrictionDate = new Date(date);
       } else {
          return -1;
       }

       if (today.getTime() >  restrictionDate.getTime()) {
           return 0;
       } else {
           return 1;
       }
    } else {
       //accessRights = anyother value
       return 1;
    }
}


function isDate(date) {

    return (new Date(date) !== "Invalid Date" && !isNaN(new Date(date)) ) ? true : false;
}

function getTypeImage(ntdl_type) {
    let imageType = "other.svg";
    if (ntdl_type) {
        ntdl_type = ntdl_type.replace(/ /g,"");
        if(typeof ntdl_type !== "undefined") {
            switch(ntdl_type) {
                case "book":            imageType = "book.svg"; break;
                case "collection":      imageType = "collection.svg"; break;
                case "dataset":         imageType = "dataset.svg"; break;
                case "debate":          imageType = "debate.svg"; break;
                case "document":        imageType = "document.svg"; break;
                case "event":           imageType = "event.svg"; break;
                case "image":           imageType = "image.svg"; break;
                case "invalidtype":     imageType = "other.svg"; break;
                case "manuscript":      imageType = "manuscript.svg"; break;
                case "map":             imageType = "map.svg"; break;
                case "mediarelease":    imageType = "mediarelease.svg"; break;
                case "movie":           imageType = "movingimage.svg"; break;
                case "movingimage":     imageType = "movingimage.svg"; break;
                case "music":           imageType = "musicscore.svg"; break;
                case "newspaper":       imageType = "newspaper.svg"; break;
                case "object":          imageType = "object.svg"; break;
                case "organisation":    imageType = "organisation.svg"; break;
                case "other":           imageType = "other.svg"; break;
                case "periodical":      imageType = "periodical.svg"; break;
                case "person":          imageType = "person.svg"; break;
                case "place":           imageType = "place.svg"; break;
                case "reference":       imageType = "reference.svg"; break;
                case "request":         imageType = "request.svg"; break;
                case "software":        imageType = "software.svg"; break;
                case "sound":           imageType = "soundrecording.svg"; break;
                case "soundrecording":  imageType = "soundrecording.svg"; break;
                case "tabledpaper":     imageType = "tabledpaper.svg"; break;
                case "thesis":          imageType = "thesis.svg"; break;
                case "website":         imageType = "website.svg"; break;
            }
        }
    }
    return imageType;
}

export function getLicenseLogo(dc_rights_code) {

  const LOCAL_URL_PREFIX = typeof window !== 'undefined' &&
      window.document && window.document.createElement
      ? window.LOCAL_URL_PREFIX
      : process.env.LOCAL_URL_PREFIX;


  var filename = "";

  var rights_code = ""

  if(dc_rights_code != null) {
     rights_code = dc_rights_code;
     rights_code = rights_code.replace("['","");
     rights_code = rights_code.replace("']","");
  } else {
     rights_code = "";
  }

  switch(rights_code) {

      case "CC BY 4.0":
            filename = "cc-by-4-0.png";
            break;

      case "CC BY-NC 4.0":
            filename = "CC-BY-NC-4-0.png";
            break;

      case "CC BY-NC-ND 4.0":
            filename = "CC-BY-NC-ND-4-0.png";
            break;

      case "CC BY-ND 4.0":
            filename = "CC-BY-ND-4-0.png";
            break;

      case "CC BY-SA 4.0":
            filename = "CC-BY-SA-4-0.png";
            break;

      case "CC BY-NC-SA 4.0":
            filename = "CC-BY-NC-SA-4-0.png";
            break;

      case "Public Domain":
            filename = "Public-Domain.png";
            break;

      case "Newspaper":
            filename = "copyrights.png";
            break;

      case "None":
            filename = "copyrights.png";
            break;

      case "Copyright":
            filename = "copyrights.png";
            break;
    }

    var path = "";

    if (filename != "") {
       path = LOCAL_URL_PREFIX + "/common/images/" + filename;
    }

    return path;
}

export function getDownloadPdfDetails(record) {
  var pdfDetails = new Object();
  if (record.haspdfdocument) {
    if (record.pdfpath != null) {
      pdfDetails.pdfpath = record.pdfpath;
      if (record.pdfsize != null) {
        pdfDetails.pdfdownloadtext = preText + "PDF " + record.pdfsize;
      } else {
        pdfDetails.pdfdownloadtext = preText + "PDF";
      }
    }
  } else {
    return null;
  }
  return pdfDetails;
}

export function getDownloadJpegDetails(record) {
  var jpegDetails = new Object();
  if (record.hasjpegimage) {
    if (record.jpegpath != null) {
      jpegDetails.jpegpath =  record.jpegpath;
      if (record.jpegsize != null) {
        jpegDetails.jpegdownloadtext = preText + "JPEG " + record.jpegsize;
      } else {
        jpegDetails.jpegdownloadtext = preText + "JPEG";
      }
    }
  } else {
    return null;
  }
  return jpegDetails;
}

export function getDownloadAudioDetails(record) {
  var audioDetails = new Object();
  if (record.hasaudio) {
    if (record.audiopath != null) {
      audioDetails.audiopath = record.audiopath;
      if (record.audiosize != null) {
        audioDetails.audiodownloadtext = preText + "Audio "+ record.audiosize;
      } else {
        audioDetails.audiodownloadtext = preText + "Audio";
      }
    }
  } else {
    return null;
  }
  return audioDetails;
}

export function getDownloadVideoDetails(record) {
  var videoDetails = new Object();
  if (record.hasvideo) {
    if (record.videopath != null) {
      videoDetails.videopath = record.videopath;
      if (record.videosize != null) {
        videoDetails.videodownloadtext = preText + "Video " + record.videosize;
      } else {
        videoDetails.videodownloadtext = preText + "Video";
      }
    }
  } else {
    return null;
  }
  return videoDetails;
}

export function getDownloadHighResTiffDetails(record) {
  var highResTiffDetails = new Object() ;
  if (record.hashighrestiff) {
    if (record.tiffpath != null) {
      if (record.hashighrestiff) {
        highResTiffDetails.highrestiffpath = record.tiffpath;
        if (record.highrestiffsize != null) {
          highResTiffDetails.highrestiffsize = preText + "High Res TIFF " + record.highrestiffsize;
          highResTiffDetails.highrestiffdownloadtext = preText + "High Res TIFF " + record.highrestiffsize;
        } else {
          highResTiffDetails.highrestiffdownloadtext = preText + "High Res TIFF";
        }
      }
    }
  } else {
    return null;
  }
  return highResTiffDetails;
}

export function getDownloadLowResTiffDetails(record) {
  var lowResTiffDetails = new Object();
  if (record.haslowrestiff) {
    if (record.tiffpath != null) {
      if (record.haslowrestiff) {
        lowResTiffDetails.lowrestiffpath = record.tiffpath;
        if (record.lowrestiffsize != null) {
          lowResTiffDetails.lowrestiffsize = preText + "Low Res TIFF " + record.lowrestiffsize;
          lowResTiffDetails.lowrestiffdownloadtext = preText + "Low Res TIFF " + record.lowrestiffsize;
        } else {
          lowResTiffDetails.lowrestiffdownloadtext = preText + "Low Res TIFF";
        }
      }
    }
  } else {
    return null;
  }
  return lowResTiffDetails;
}

export function getDownloadUnknownTypeDetails(record) {
  var details = new Object();
  if (record.hasunknownfiletype) {
    if (record.unknowntypefilepath != null) {
      details.unknowntypefilepath = record.unknowntypefilepath;
      details.unknowntypefileextn = record.unknowntypefileextn;
      details.unknowntypefilesize = record.unknowntypefilesize;
      if (details.unknowntypefilesize != null) {
        details.unknowntypedownloadtext = preText + details.unknowntypefileextn + ' file ' + details.unknowntypefilesize;
      } else {
        details.unknowntypedownloadtext = 'Download file';
      }
    }
  } else {
    return null;
  }
  return details;
}

export function getDownloadEpubDetails(record) {
  var details = new Object();
  if (record.hasepubdocument) {
    if (record.epubpath != null) {
      details.epubdownloadpath = record.epubpath;
      details.epubdownloadsize = record.epubsize;
      if (details.epubdownloadsize != null) {
        details.epubdownloadtext = preText + 'EPUB file ' + details.epubdownloadsize;
      } else {
        details.epubdownloadtext = preText + 'EPUB';
      }
    }
  } else {
    return null;
  }
  return details;
}

export function checkDownloadExists(record) {
  if (getDownloadPdfDetails(record) != null) {
    return true;
  }
  if (getDownloadJpegDetails(record)!=null) {
    return true;
  }
  if (getDownloadAudioDetails(record) != null) {
    return true;
  }
  if (getDownloadVideoDetails(record) != null) {
    return true;
  }
  if (getDownloadHighResTiffDetails(record) != null) {
    return true;
  }
  if (getDownloadLowResTiffDetails(record) != null) {
    return true;
  }
  if (getDownloadUnknownTypeDetails(record) != null) {
    return true;
  }
  if (getDownloadEpubDetails(record) != null) {
    return true;
  }
  return false;
}


function getLicenceText(rights_code) {

   rights_code = rights_code.replace("[","");

   rights_code = rights_code.replace("]","");

   rights_code = rights_code.replace("\'","");

   rights_code = rights_code.replace(/'/g,"");

   var licence_text = "";

   switch(rights_code) {
     case "CC BY 4.0":
          licence_text = "You are free to copy and redistribute the material in any medium or format, remix, transform, and build upon the material for any purpose, even commercially.";
          break;

     case "CC BY-NC 4.0":
          licence_text = "You are free to copy and redistribute the material in any medium or format. remix, transform, and build upon the material you must indicate if changes were made. You may not use the material for commercial purposes without permission of the copyright owner.";
          break;

     case "CC BY-NC-ND 4.0":
          licence_text = "You are free to copy and redistribute the material in any medium or format. You may not use the material for commercial purposes. If you remix, transform, or build upon the material for private purpses, you may not distribute the modified material."
          break;

     case "CC BY-ND 4.0":
          licence_text = "You are free to copy and redistribute the material in any medium or format for any purpose, even commercially. If you remix, transform, or build upon the material for private purposes, you may not distribute the modified material."
          break;

     case "CC BY-SA 4.0":
          licence_text = "You are free to copy and redistribute the material in any medium or format, remix, transform, and build upon the material for any purpose, even commercially. You must distribute derived content under the same license as the original."
          break;

     case "CC BY-NC-SA 4.0":
          licence_text = "You are free to copy and redistribute the material in any medium or format,  remix, transform, and build upon the material. You may not use the material for commercial purposes without permission of the copyright holder. You must distribute and derived content under the same license as the original."
          break;

     case "Public Domain":
          licence_text = "You are free to copy and redistribute the material in any medium or format, remix, transform, and build upon the material for any purpose, even commercially."
          break;

     case "NTL Donor":
          licence_text = "";
          break;

     case "Newspaper":
          licence_text = "";
          break;

     case "StoryNT":
          licence_text = "";
          break;

     case "Cyclone Tracy":
          licence_text = "";
          break;

     case "Being a Territory":
          licence_text = "";
          break;

     case "None":
          licence_text = "";
          break;

     case "Copyright":
          licence_text = "";
          break;
     case "Media Release":
          licence_text = "";
          break;
    }

    return licence_text;
}

export function getRecordTitle(title) {

    var record_title = title.replace(/\[\'([^\']+)\'[,]*.*\]/,"$1");

    return record_title;
}

export function translateCopyrightCode(CC) {
    //  Eg: "CC BY-NC 4.0" --> "cc_by_nc_4_0"
    //  This is used to address items in the Copyrights Grid
    //  either via .js file for via Django.
    //  Eg: name = CopyrightBehaviourGrid[translateCopyrightCode("CC BY-NC 4.0")]["name"]
    //  Eg: name = CopyrightBehaviourGrid["cc_by_nc_4_0"]["name"]
    let codeRegex1 =  /\['([^']+)'\]/;
    let codeRegex2 =  /[-_ \t\.]+/g;
    return CC.toLowerCase().replace(codeRegex1,"$1").replace(codeRegex2,"_");
}

export function getDownloadDetails(record,fullMetaObject) {

    // Define an empty object to return the details
    var downloadDetails = new Object();

    // Get the S3 URL Prefix to use for icons
    const LOCAL_URL_PREFIX = typeof window !== 'undefined' &&
        window.document && window.document.createElement
        ? window.LOCAL_URL_PREFIX
        : process.env.LOCAL_URL_PREFIX;

    // If there is no record.dc_rights_code, or if it is 'No CODE', use 'No CODE':
    // NTDL-857 - Note that we only use the first code if there are multiple codes
    // NTDL-857 - so we use extractStringOne() instead of extractString()
    let record_dc_rights_code;
    if ((record.dc_rights_code != "") && (record.dc_rights_code != undefined) && (record.dc_rights_code != null)) {
      record_dc_rights_code = extractStringOne(record.dc_rights_code);
    } else {
      record_dc_rights_code = 'No CODE';
    }

    // Translate the code value into a key for the data:
    let rights_code = translateCopyrightCode(record_dc_rights_code);
    // Debug for the copyright code
    //console.log(`Copyright Code: ${record_dc_rights_code} --> ${rights_code}`)

    // Some records have incorrect rights codes.
    // Eg: "StoryNT Agreement" v.s. "StoryNT"
    // Just default to 'Empty' for these, guessing is a mugs game.
    if (!CopyrightBehaviourGrid.hasOwnProperty(rights_code)) {
      console.log(`Warning: dc.rights.code "${record_dc_rights_code}" does not exist, using Empty values for copyright text, logo and link.`);
      // Don't use 'No CODE', just make everything empty now. NTDL-405
      record_dc_rights_code = 'Empty';
      rights_code = translateCopyrightCode(record_dc_rights_code);
    }

    // OK, now, let's get the details from the Django Copyrights app
    // or fall back to the metadata, failing that, use default text.
    if (!CopyrightBehaviourGrid.hasOwnProperty(rights_code)) {
      console.log(`Warning: dc.rights.code "${record_dc_rights_code}" does not exist, using NULL values.`);
      downloadDetails.value = "";
      downloadDetails.name = "";
      downloadDetails.copyright_link = "";
      downloadDetails.summary = "";
      downloadDetails.notes = "";
      downloadDetails.icon = "";
    } else {
      //console.log(`DEBUG: using dc.rights.code "${record_dc_rights_code}"`);
      downloadDetails.value = CopyrightBehaviourGrid[rights_code]["value"];
      downloadDetails.name = (record_dc_rights_code == 'No CODE') ? (
        (record.dc_rights != '') ? extractString(record.dc_rights) : CopyrightBehaviourGrid[rights_code]["name"]
      ) : (
        CopyrightBehaviourGrid[rights_code]["name"]
      );
      downloadDetails.copyright_link = CopyrightBehaviourGrid[rights_code]["link"];
      downloadDetails.summary = CopyrightBehaviourGrid[rights_code]["summary"];
      downloadDetails.notes = CopyrightBehaviourGrid[rights_code]["notes"];
      downloadDetails.icon = CopyrightBehaviourGrid[rights_code]["icon"];
    }

    // Add record.dc_rights for ICIP licence:
    // * Actually, we no longer do this, as per NTDL-405
    // * But the code can stay here just in case...
    //if (record_dc_rights_code == 'ICIP') {
    //  downloadDetails.name = (downloadDetails.name) ? `${downloadDetails.name} ${extractString(record.dc_rights)}` : downloadDetails.name;
    //  downloadDetails.summary = (downloadDetails.summary) ? `${downloadDetails.summary} ${extractString(record.dc_rights)}` : downloadDetails.summary;
    //}

    // If the icon link starts with '/' then pre-pend the S3 base URL
    if ((downloadDetails.icon != undefined) && (downloadDetails.icon != null) && (downloadDetails.icon.startsWith('/'))) {
      downloadDetails.icon = `${LOCAL_URL_PREFIX}${downloadDetails.icon}`;
    }

    // Fallback to the (C) logo for "Copyright".
    if (downloadDetails.icon.toLowerCase() == 'copyright') {
        downloadDetails.icon = `${LOCAL_URL_PREFIX}/common/images/copyrights.png`;
    }

    // Remove the copyright link for "none" or similar.
    if ((downloadDetails.link != undefined) && (downloadDetails.link != null) && (downloadDetails.copyright_link.toLowerCase() == 'none')) {
        downloadDetails.copyright_link = null;
    }

    // Remove the copyright logo for "none" or similar.
    if ((downloadDetails.icon != undefined) && (downloadDetails.icon != null) && (downloadDetails.icon.toLowerCase() == 'none')) {
        downloadDetails.icon = null;
    }

    if (fullMetaObject['Photographer'] != null) {
        downloadDetails.photographer = getValueFromFullMetaObject(fullMetaObject,'Photographer');
    } else {
        downloadDetails.photographer = "";
    }

    // Only 3 contributors maximum is allowed
    // After 3 contributors we have to add ", et al.," at end
    if ((record.contributors != null) && (record.contributors.length > 0)) {
       var contributor_field = "";
       for (var i =0; i < record.contributors.length; i++) {
           var strTemp = extractString(record.contributors[i]).replace(".","").trim();
           if (i < 3) {
               if (strTemp.endsWith(","))
                   contributor_field += strTemp + " ";
               else
                   contributor_field += strTemp + ", ";
           }
           else {
               contributor_field += ", et al.";
               break;
           }
       }
       downloadDetails.contributor = contributor_field;
    }

    // Collections
    // NTDL-405 - new rules... see also NTDL-852
    //
    //   Don't use dc.relation.incommunity,
    //   if there is dc.relation.ispartof use that and nothing else.
    //   Else use dc.relation.incollection
    //
    // * This is not possible as we don't have the metadata
    //
    // Need to add these to the harvester NTDL-852 (some won't be used)
    // in models.py, and in the ntdl_v01 index
    // * dc_relation_incommunity
    // * dc_relation_ispartof
    // * dc_relation_ispartofseries
    // * dc_relation_incollection - already exists, use as a template.
    //console.log(`dc_relation_incollection = ${record.dc_relation_incollection}`);
    //console.log(`dc_relation_incommunity = ${record.dc_relation_incommunity}`);
    //console.log(`dc_relation_ispartof = ${record.dc_relation_ispartof}`);
    //console.log(`dc_relation_ispartofseries = ${record.dc_relation_ispartofseries}`);
    //
    // old collection has dc.relation.incommunity (old records in harvestor)
    // but new the following fields in collection:
    //   'Collection',[
    //    'dc.relation.ispartof',
    //    'dc.relation.incollection',
    //    'dc.relation.incommunity',
    //    'dc.relation.ispartofseries'
    //   ]
    // dc.relation.incommunity should be there for collection as per Kerry's requirement
    // what about dc.relation.ispartof and dc.relation.ispartofseries in collection.
    // - Confirm with Kerry
    //
    // NTDL-405 - If collection name doesn't have "Collection" then add it.
    //
    if ((record.dc_relation_ispartof != undefined) && (record.dc_relation_ispartof != null) && (record.dc_relation_ispartof != '')) {
      //console.log(`record.dc_relation_ispartof = ${record.dc_relation_ispartof}`);
      // Convert the list to an array = this would be better if it was
      // already in JSON, but the single quotes make everything hard.
      // ['one', 'two', ... ]
      // So, use this regular expression
      // /["']*\s*(?:,|$)\s*["']*/
      //   ["']+\s* : at least one single or double quote followed by zero or more spaces
      //   (?:,|$)  : a group of a comma, or end of line
      //   \s*["']+ : zero or more spaces followed by at least one single or double quote
      let dc_relation_ispartof_arr = record.dc_relation_ispartof.replace(/^\[[\'\"]/,'').replace(/[\'\"]\]$/,'').trim().split(/["']+\s*(?:,|$)\s*["']+/);
      //console.log(`dc_relation_ispartof_arr = ${dc_relation_ispartof_arr}`);
      //console.log(dc_relation_ispartof_arr);
      // Check each ispartof name, add 'Collection' and make a list
      let dc_relation_ispartof_length = dc_relation_ispartof_arr.length;
      let temp_dc_relation_ispartof = '';
      for (var i = 0; i < dc_relation_ispartof_length; i++) {
        let ispartof_name = dc_relation_ispartof_arr[i].trim();
        //console.log(`ispartof_name = ${ispartof_name}`);
        if (!ispartof_name.includes('Collection')) {
          ispartof_name += ' Collection';
        }
        if (i < (dc_relation_ispartof_length-1)) {
          temp_dc_relation_ispartof += ispartof_name+', ';
        } else {
          temp_dc_relation_ispartof += ispartof_name;
        }
        //console.log(`temp_dc_relation_ispartof = ${temp_dc_relation_ispartof}`);
      }
      downloadDetails.collection_list = temp_dc_relation_ispartof;
    } else if ((record.dc_relation_incollection != undefined) && (record.dc_relation_incollection != null) && (record.dc_relation_incollection != '')) {
      downloadDetails.collection_list = (record.dc_relation_incollection.includes('Collection')) ? extractString(record.dc_relation_incollection) : extractString(record.dc_relation_incollection) + ' Collection';
    } else {
      downloadDetails.collection_list = null
    }
    //console.log(`downloadDetails.collection_list = ${downloadDetails.collection_list}`);

    // NTDL-405 - Display the Volume info in the Attribution string
    if (fullMetaObject['Volume'] != null) {
       downloadDetails.volume = getValueFromFullMetaObject(fullMetaObject,'Volume');
    } else {
       downloadDetails.volume = "";
    }

    if (fullMetaObject['Date'] != null) {
       downloadDetails.date = getValueFromFullMetaObject(fullMetaObject,'Date');
    } else {
       downloadDetails.date = "";
    }

    if (fullMetaObject['Citation address'] != null) {
        downloadDetails.bitstream_handle = record.handle;
    } else {
       downloadDetails.bitstream_handle = "";
    }
	
    if (record.dcterms_accessrights != null) {
       downloadDetails.dcterms_accessrights = record.dcterms_accessrights;
    } else {
       downloadDetails.dcterms_accessrights = "";
    }

    if (record.dcterms_accessrights_code != null) {
       downloadDetails.dcterms_accessrights_code = record.dcterms_accessrights_code;
    } else {
       downloadDetails.dcterms_accessrights_code = "";
    }

    if (record.dc_rights != null) {
        downloadDetails.dc_rights =  record.dc_rights;
    } else {
        downloadDetails.dc_rights = "";
    }

    if (record.dc_rights_code != null) {
        downloadDetails.dc_rights_code = record.dc_rights_code;
        downloadDetails.dc_license_text = getLicenceText(record.dc_rights_code);
    } else {
        downloadDetails.dc_rights_code = "";
    }

    if (record.dc_rights_holder != null) {
        if (record.dc_rights_code != "Public Domain") {
            downloadDetails.dc_rights_holder = record.dc_rights_holder;
        } else {
            downloadDetails.dc_rights_holder = "";
        }
    } else {
        downloadDetails.dc_rights_holder = "";
    }

    if (record.dc_rights_license != null) {
        var rights_license = record.dc_rights_license;
        rights_license = rights_license.replace("[","");
        rights_license = rights_license.replace("]","");
        rights_license = rights_license.replace(/'/g,"");

        if (rights_license.endsWith("/")) {
            rights_license = rights_license.slice(0,-1);
        }

        downloadDetails.dc_rights_license = rights_license;
    } else {
        downloadDetails.dc_rights_license = "";
    }

    if (record.dc_title != null) {
        downloadDetails.dc_title = record.dc_title;
    } else {
        downloadDetails.dc_title = "";
    }

    if (record.dc_creator_author != null) {
        downloadDetails.dc_creator_author = record.dc_creator_author;
    } else {
        downloadDetails.dc_creator_author = "";
    }

    if (record.dc_relation_incollection != null) {
        downloadDetails.dc_relation_incollection = record.dc_relation_incollection;
    } else {
        downloadDetails.dc_relation_incollection = "";
    }

    if (record.dc_identifier_other != null) {
        downloadDetails.dc_identifier_other = record.dc_identifier_other;
    } else {
        downloadDetails.dc_identifier_other = "";
    }

    if (record.linktype != null) {
        downloadDetails.linktype = record.linktype;
    } else {
        downloadDetails.linktype = "";
    }

    if (record.link != null) {
        downloadDetails.link = record.link;
    } else {
        downloadDetails.link = "";
    }

    downloadDetails.hastiffimage = record.hastiffimage;
    downloadDetails.haspdfdocument =  record.haspdfdocument;
    downloadDetails.hasaudio = record.hasaudio;
    downloadDetails.hasvideo = record.hasvideo;
    downloadDetails.haslowrestiff = record.haslowrestiff;
    downloadDetails.hashighrestiff = record.hashighrestiff;
    downloadDetails.hasjpegimage = record.hasjpegimage;
    downloadDetails.hasunknownfiletype = record.hasunknownfiletype;
    downloadDetails.hasepubdocument = record.hasepubdocument;
    downloadDetails.viewer = record.viewer;

    if (record.highrestiffsize != null) {
        downloadDetails.highrestiffsize = record.highrestiffsize;
    }

    if (record.lowrestiffsize != null) {
        downloadDetails.lowrestiffsize = record.lowrestiffsize;
    }

    if (record.jpegsize != null) {
        downloadDetails.jpegsize = record.jpegsize;
    }

    if (record.pdfsize != null) {
        downloadDetails.pdfsize = record.pdfsize;
    }

    if (record.audiosize != null) {
        downloadDetails.audiosize = record.audiosize;
    }

    if (record.videosize != null) {
        downloadDetails.videosize = record.videosize;
    }

    if (record.unknowntypefilesize != null) {
        downloadDetails.unknowntypefilesize = record.unknowntypefilesize;
    }

    if (record.epubsize != null) {
        downloadDetails.epubsize = record.epubsize;
    }

    downloadDetails.jpegpath = "";
    downloadDetails.tiffpath = "";
    downloadDetails.pdfpath = "";
    downloadDetails.audiopath = "";
    downloadDetails.videopath = "";
    downloadDetails.audiextn = "";
    downloadDetails.videoextn ="";
    downloadDetails.unknowntypefilepath = "";
    downloadDetails.unknowntypefileextn = "";
    downloadDetails.epubpath = "";

    if (record.jpegpath != null) {
        downloadDetails.jpegpath = record.jpegpath;
    }

    if (record.tiffpath != null) {
        downloadDetails.tiffpath = record.tiffpath;
    }

    if (record.pdfpath != null) {
        downloadDetails.pdfpath =  record.pdfpath;
    }

    if (record.audiopath != null) {
        downloadDetails.audiopath = record.audiopath;
        downloadDetails.audioextn = record.audioextn;
    }

    if (record.videopath != null) {
        downloadDetails.videopath = record.videopath;
        downloadDetails.videoextn = record.videoextn;
    }

    if (record.unknowntypefilepath != null) {
        downloadDetails.unknowntypefilepath =  record.unknowntypefilepath;
        downloadDetails.unknowntypefileextn =  record.unknowntypefileextn;
    }

    if (record.epubpath != null) {
        downloadDetails.epubpath =  record.epubpath;
    }

    // Debug only
    //console.log(downloadDetails);

    return downloadDetails;
}

export function getOverlayImage (LOCAL_URL_PREFIX,ntdl_type)  {

    if (ntdl_type == undefined) {
        return;
    }

    if (ntdl_type != undefined) {
        ntdl_type = ntdl_type.toLowerCase();
        ntdl_type = ntdl_type.replace(/\+/g,'');
        return LOCAL_URL_PREFIX + "/generic/" + getTypeImage(ntdl_type);
    }
}

export function getSourceBrand (LOCAL_URL_PREFIX,source) {
      var brand;

      switch(source) {
          case 'ts':
              brand = LOCAL_URL_PREFIX + '/generic/ts.png';
              break;
          case 'trove':
              brand = LOCAL_URL_PREFIX + '/generic/trove.jpg';
              break;
          case 'lms':
              brand = LOCAL_URL_PREFIX +  '/generic/lms.jpg';
              break;
      }

      //brand = LOCAL_URL_PREFIX + "/generic/ts.png";

      return brand;
}

export function restrictTo_X_Chars(title,length) {
    if ((!title) || (title.length < length)) {
        return title;
    } else {
        // The longest Aust place name is 27 chars
        //  "Mamungkukumpurangkuntjunya"
        // The longest word in /usr/share/dict/words is 23 chars
        //  "electroencephalographs"
        // Only 8 words are longer than 20 chars, save 4 chars for ' ...'
        let min = length - 24;
        let max = length - 4;
        let regex_string = `^.\{${min},${max}\}\\s`;
        let regex = new RegExp(regex_string);
        //console.log('Regex is: "' + regex + '"');
        let trimmedTitle = title.match(regex) + '...';
        //console.log('Replaced: ' + title + ' With: ' + trimmedTitle);
        return trimmedTitle;
    }
}

export function restrictTo70Chars(title) {

     var length = 70;
     var trimmedTitle = title.length > length ?
                    title.substring(0, length - 3) + "..." :
                    title;

     return trimmedTitle;
}

export function display2ndLine(date, ntdl_type, tabled_paper, title_alt, thumbnail_size) {

    // If there's no ntdl_type, just return
    if (ntdl_type == undefined) {
        return;
    }

    // If ntdl_type == "related items", just return, this is the "dummy item".
    if (ntdl_type == "related items") {
        return;
    }

    // Otherwise return a string with the date & other info
    var dateStr = date.toString();

    // ntdl_type and other keyword types are now in lowercase
    var typeStr = titleCase(ntdl_type.toString());

    // ------------------------------------------------------------------
    // Large:   thumbnailSize == 1.0
    // Medium:  thumbnailSize == 0.75
    // Small:   thumbnailSize == 0.5
    // Related: thumbnailSize == 0.25
    // List:    thumbnailSize == 0
    // ------------------------------------------------------------------

    // If the dc.title.alternate is supplied, we'll use that
    if ((title_alt != undefined) && (title_alt != null)) {
        if (((thumbnail_size == 0) || (thumbnail_size >= 0.75)) && (dateStr.length > 0)) {
            return dateStr.concat(" | ").concat(titleCase(title_alt.toLowerCase()));
        } else {
            return titleCase(title_alt.toLowerCase());
        }
    }

    // Tabled Papers are a little different
    if (typeStr === 'Tabled Paper') {
        if ((tabled_paper != undefined) && (tabled_paper != null)) {
            typeStr = tabled_paper.toString();
            typeStr = typeStr.replace(/["']/g,"");
        }
    }

    // Otherwise, just use the date and NTDL item type
    var SecondLine;
    if ((dateStr.length > 0) && (typeStr.length > 0)){
        SecondLine = dateStr.concat(" | ").concat(typeStr);
    }
    if (dateStr.length == 0) {
       if(typeStr.length == 0) {
           SecondLine = "";
       } else {
           SecondLine = typeStr;
       }
    } else {
       if (typeStr.length == 0) {
           SecondLine = dateStr;
       }
    }

    return SecondLine;

}

export function checkThumbnail(thumbnail, ntdl_type,source) {
    /*
    var endString = ""

    if (thumbnail != undefined) {
        endString = thumbnail.substr(thumbnail.length - 20);
    }
    */

    // Assume the item has a thumbnail
    var returnVal = true;

    // Convert ntdl_type to lowercase and strip spaces
    if(ntdl_type != undefined) {
      ntdl_type = ntdl_type.toLowerCase();
      ntdl_type = ntdl_type.replace(/ /g,"");
    }

    // Check by source - Note: indices differ from PosgreSQL and Elasticsearch:
    // 1 = TS                   - has thumbnail for some types
    // 2 = LMS                  - false - no thumbnail
    // 3 = Trove                - true - has thumbnail
    // 4 = IndexNT              - false - no thumbnail
    // 5 = Legislative Assembly - true - has thumbnail
    if (source == 1) { //TS
      //if((ntdl_type != undefined) && (ntdl_type == 'reference' || ntdl_type == 'music' || ntdl_type == 'movie' || ntdl_type == 'person' || ntdl_type == 'soundrecording')) {
      if((ntdl_type != undefined) && (ntdl_type == 'music' || ntdl_type == 'soundrecording')) {
        return false;
      } else {
        return true;
      }
    } else if (source == 2) { //LMS
      return false;
    } else if (source == 3) { //Trove
      return true;
    } else if (source == 4) { //IndexNT
      return false;
    } else if (source == 5) { //LegislativeAssembly
      return true;
    }
    /*
    if(endString.endsWith('reference.jpg'))
      return false;
    else
      return true;
    */
}

// Determine the background image based on categories
export function getTypeBackgroundImage(ntdl_type,source) {
    // source = 5 is LegislativeAssembly
    // source = 4 is IndexNT
    // source = 3 is Trove
    // source = 2 is LMS
    // source = 1 is TS or Digital NTL
    // RJG - Other sources don't get a default image...?
    if(ntdl_type != undefined) {
        ntdl_type = ntdl_type.toLowerCase();
        ntdl_type = ntdl_type.replace(/ /g,"");
    } else {
        ntdl_type = "invalidtype";
    }
    var imageType = "";
    // This is all quite clumsy, should just do it with regex
    if (source == 3) {
        if ( ntdl_type == "invalidtype" ) { imageType = "other.svg"; } else
        imageType = ntdl_type + ".svg";
        {/*
        switch(ntdl_type) {
            case "image":         imageType = "image.svg"; break;
            case "newspaper":     imageType = "newspaper.svg"; break;
        }
        */}
    } else if (source == 2) {
        if ( ntdl_type == "music" ) { imageType = "musicalscore.svg"; } else
        if ( ntdl_type == "sound" ) { imageType = "soundrecording.svg"; } else
        if ( ntdl_type == "video" ) { imageType = "movingimage.svg"; } else
        if ( ntdl_type == "invalidtype" ) { imageType = "other.svg"; } else
        imageType = ntdl_type + ".svg";
        {/*
        switch(ntdl_type) {
            case "book":          imageType = "book.svg"; break;
            case "image":         imageType = "image.svg"; break;
            case "map":           imageType = "map.svg"; break;
            case "other":         imageType = "other.svg"; break;
            case "music":         imageType = "music.svg"; break;
            case "periodical":    imageType = "periodical.svg"; break;
            case "sound":         imageType = "soundrecording.svg"; break;
            case "reference":     imageType = "reference.svg"; break;
            case "music":         imageType = "music.svg"; break;
            case "musicalscore":  imageType = "musicalscore.svg"; break;
            case "movingimage":   imageType = "movingimage.svg"; break;
            case "software":      imageType = "software.svg"; break;
            case "manuscript":    imageType = "manuscript.svg"; break;
            case "invalid type":  imageType = "other.svg"; break;
        }
        */}
    } else if (source == 1) {
        if ( ntdl_type == "movie" ) { imageType = "movingimage.svg"; } else
        if ( ntdl_type == "sound" ) { imageType = "soundrecording.svg"; } else
        if ( ntdl_type == "invalidtype" ) { imageType = "other.svg"; } else
        imageType = ntdl_type + ".svg";
        {/*
        switch(ntdl_type) {
            case "image":         imageType = "image.svg"; break;
            case "invalid type":  imageType = "other.svg"; break;
            case "movie":         imageType = "movingimage.svg"; break;
            case "person":        imageType = "person.svg"; break;
            case "reference":     imageType = "reference.svg"; break;
            case "soundrecording": imageType = "soundrecording.svg"; break;
        }
        */}
    } else {
        imageType = ntdl_type + ".svg";
    }
    return imageType;
}

// Create the full generic thumbnail path based on categories
export function getBackgroundImage(LOCAL_URL_PREFIX,ntdl_type,source) {
    let tempstr;
    if (ntdl_type === 'relateditems') {
      tempstr = 'related_items.png';
    } else {
      tempstr = getTypeBackgroundImage(ntdl_type,source);
    }
    let thumbnail = LOCAL_URL_PREFIX + "/thumbnails/" + tempstr;
    return thumbnail;
}

// Used for the background where there is no thumbnail image
// and a generic thumbnail is used based on categories
export function getBackgroundImageColor(LOCAL_URL_PREFIX,ntdl_type,source) {
    var backgroundColor = "var(--lant_grey_7)";
    var thumbnail = getBackgroundImage(LOCAL_URL_PREFIX,ntdl_type,source);
    var thumbFileName = thumbnail.split('\\').pop().split('/').pop();
    var thumbFileNameSplit = thumbFileName.split('.')[0];
    if ( thumbFileName == "" ) { backgroundColor = "var(--lant_grey_7)"; } else
    backgroundColor = "var(--lant_" + thumbFileNameSplit + ")";
    // This is clumsy - should do it with a split instead
    {/*
    switch(thumbFileName) {
        case "book.svg":            backgroundColor = "var(--lant_book)"; break;
        case "image.svg":           backgroundColor = "var(--lant_image)"; break;
        case "manuscript.svg":      backgroundColor = "var(--lant_manuscript)"; break;
        case "map.svg":             backgroundColor = "var(--lant_map)"; break;
        case "music.svg":           backgroundColor = "var(--lant_music)"; break;
        case "other.svg":           backgroundColor = "var(--lant_other)"; break;
        case "periodical.svg":      backgroundColor = "var(--lant_periodical)"; break;
        case "person.svg":          backgroundColor = "var(--lant_person)"; break;
        case "reference.svg":       backgroundColor = "var(--lant_reference)"; break;
        case "software.svg":        backgroundColor = "var(--lant_software)"; break;
        case "soundrecording.svg":  backgroundColor = "var(--lant_soundrecording)"; break;
        case "video.svg":           backgroundColor = "var(--lant_video)"; break;
    }
    */}
    return backgroundColor;
}

// Used for the background where there is a thumbnail image
export function getBackgroundColor(thumbnail) {
    var endString = thumbnail.substr(thumbnail.length - 20);
    var backgroundColor = "var(--lant_grey_7)";
    if (endString.endsWith('reference.jpg')) {
        backgroundColor = "var(--lant_reference)";
    }
    return backgroundColor;
}

// This function prevents the propagation of events, used
// for clickable links within a <div> that has onClick() set
// See below in clickableLinkFromKeyVal() too.
export function stopClick(e) {
  // Debug output so we know what's going on.
  //console.log('stopClick(e) prevented default for clickable link');
  // This sets e.defaultPrevented if other events check it.
  e.preventDefault();
  // This stops the current event from porpagating.
  e.stopPropagation();
}

// A function to turn key/value into clickable links
// We add stopClick() to onMouseUp() as the containing
// <div> doesn't actually use onClick()
// See above in stopClick() too.
export function clickableLinkFromKeyVal(key,value,value_text, index, length) {
  // Debug output only
  //console.log('clickableLinkFromItem() - key=' + key + ' ,value=' + value);

  // The list of contributors...
  // Note: The list above is created from the harvester code.
  // See: NTDL-707
  // See: ~/src/harvestor-2/harvest-territory-stories/dspacelant/fetch.py
  // Run: ~/utils/ntdl_contributors_list.sh
  // * Would be better to use something like new_records_lookup.js
  // See: NTDL-860
  var contrib_list = ['advisor','arranger','author','cartographer','commissioningbody','compiler','composer','contributor','corpauthor','corpcartographer','corpcompiler','corpcomposer','corpeditor','corpillustrator','corplyricist','corpsurveyor','creator','editor','illustrator','interviewee','interviewer','issuingbody','lyricist','member','other','party','photographer','sponsor','surveyor','translator','contributor']

  // Add ' ;' to continuing items - '\u00A0' is a non-breaking space
  // This simplifies the code below into a single return() for each case
  var semi_colon = (((index != -1) && (length != -1)) && (index < (length -1))) ? ('\u00A0;') : null;

  // Now for each metadata key, create the link
  if (key.toLowerCase() == 'related links') {
    if ((value_text != null) && (value_text != undefined)) {
      var link_text = value_text.substring(1,value_text.length-1);
      return (
        <a className="clickableLinkDiv anchorGrey" href={(value.indexOf('http://') == 0 || value.indexOf('https://') == 0) ? value : 'https://' + value}>
          <p className="clickableLinkPara">{link_text}{semi_colon}</p>
        </a>
      );
    } else {
      return (
        <a className="clickableLinkDiv anchorGrey" href={(value.indexOf('http://') == 0 || value.indexOf('https://') == 0) ? value : 'https://' + value}>
          <p className="clickableLinkPara">{(value.indexOf('http://') == 0 || value.indexOf('https://') == 0) ? value : 'https://' + value}{semi_colon}</p>
        </a>
      );
    }
  } else if ((key.toLowerCase() == 'citation address')
      || (key.toLowerCase() == 'handle')
      || (key.toLowerCase() == 'license')
      || (key.toLowerCase() == 'parent handle')
      || (key.toLowerCase() == 'related items')) {
    return (
      <a className="clickableLinkDiv anchorGrey" href={(value.indexOf('http://') == 0 || value.indexOf('https://') == 0) ? value : 'https://' + value}>
        <p className="clickableLinkPara">{(value.indexOf('http://') == 0 || value.indexOf('https://') == 0) ? value : 'https://' + value}{semi_colon}</p>
      </a>
    );
  } else if ((key.toLowerCase() == 'appears in collection')
      || (key.toLowerCase() == 'appears in collections')
      || (key.toLowerCase() == 'collection')
      || (key.toLowerCase() == 'collections')) {
    return (
      <a className="clickableLinkDiv anchorGrey" href={"/?collection=" + encodeURIComponent(value.toLowerCase())} onMouseUp={(e) => stopClick(e)}>
        <p className="clickableLinkPara">{value}{semi_colon}</p>
      </a>
    );
  } else if (key.toLowerCase() == 'language') {
    return (
      <a className="clickableLinkDiv anchorGrey" href={"/?language=" + encodeURIComponent(value.toLowerCase())} onMouseUp={(e) => stopClick(e)}>
        <p className="clickableLinkPara">{value}{semi_colon}</p>
      </a>
    );
  } else if (key.toLowerCase() == 'location') {
    return (
      <a className="clickableLinkDiv anchorGrey" href={"/?location=" + encodeURIComponent(value.toLowerCase())} onMouseUp={(e) => stopClick(e)}>
        <p className="clickableLinkPara">{value}{semi_colon}</p>
      </a>
    );
  } else if (key.toLowerCase() == 'subject') {
    return (
      <a className="clickableLinkDiv anchorGrey" href={"/?subject=" + encodeURIComponent(value.toLowerCase())} onMouseUp={(e) => stopClick(e)}>
        <p className="clickableLinkPara">{value}{semi_colon}</p>
      </a>
    );
  } else if (contrib_list.includes(key.toLowerCase())) {
    return (
      <a className="clickableLinkDiv anchorGrey" href={"/?contributor=" + encodeURIComponent(value.toLowerCase())} onMouseUp={(e) => stopClick(e)}>
        <p className="clickableLinkPara">{value}{semi_colon}</p>
      </a>
    );
  } else {
    return (
      <div className="clickableLinkDiv">
        {value}{semi_colon}
      </div>
    );
  }
}

// RJG - place a 30x30 (ish) brand image in the bottom left
// RJG - pointer-events is set to none to allow pass-through
// RJG - all branddiv style is in _search.scss
export function getBrandBlock(i,width,height,LOCAL_URL_PREFIX) {
  // Brand images are based on the item source,
  // may not need LOCAL_URL_PREFIX, but keep it for consistency
  let brandBlock = (i?.source?.brand) ? (
    <div className="branddiv" style={{width:width,height:height}}>
      <img src={i?.source?.brand} className="card-img-top" style={{width:width,height:height}} alt={i.source}/>
    </div>
  ) : null ;
  return(brandBlock);
}

// RJG - place a 30x30 (ish) filetype image in the bottom right
// RJG - pointer-events is set to none to allow pass-through
// RJG - all filetypediv style is in _search.scss
export function getFiletypeBlock(i,width,height,LOCAL_URL_PREFIX) {
  let filetypeBlock = null;
  let filetype_alt = null;
  let filetype_icon = null;
  // RJG - yes, this has become quite messy...
  // RJG - It's VERY important that TIFF comes before JPEG
  if ( i.hasaudio == true ) {
    filetype_alt = 'MP3';
    filetype_icon = '/brand/filetype_mp3.svg';
  } else if ( i.hasepubdocument == true ) {
    filetype_alt = 'EPUB';
    filetype_icon = '/brand/filetype_epub.svg';
  } else if ( i.hastiffimage == true ) {
    filetype_alt = 'TIF';
    filetype_icon = '/brand/filetype_tif.svg';
  } else if ( i.hasjpegimage == true ) {
    filetype_alt = 'JPG';
    filetype_icon = '/brand/filetype_jpg.svg';
  } else if ( i.haspdfdocument == true ) {
    filetype_alt = 'PDF';
    filetype_icon = '/brand/filetype_pdf.svg';
  } else if ( i.hasvideo == true ) {
    filetype_alt = 'MP4';
    filetype_icon = '/brand/filetype_mp4.svg';
  } else if (( i.hasOwnProperty('external_link') == true ) && (i.external_link !== null)) {
    filetype_alt = 'LINK';
    filetype_icon = '/brand/filetype_link.svg';
  }
  if ( filetype_icon !== null ) {
    filetypeBlock = (
      <div className="filetypediv" style={{width:width,height:height}}>
        <img src={LOCAL_URL_PREFIX + filetype_icon} className="card-img-top" style={{width:width,height:height}} alt={filetype_alt}/>
      </div>
    );
  } else {
    filetypeBlock = null;
  }
return(filetypeBlock);
}

// A function to filter an array for distinct values
export function arrayDistinct(value, index, self) {
  return self.indexOf(value) === index;
}

// Create a metadata object from a list of pairs of strings
export function createFullMetaObject(metaList) {

    // Sanity check...
    if (!metaList) {
        return metaList;
    }

    // Build an object from pairs in the list
    let realMetaObject = {};
    for (let i = 0; i < metaList.length; i++) {
      realMetaObject[metaList[i]] = metaList[i+1];
      i += 1;
    }

    // Now check each metadata key...
    var fullMetaObject={};
    for (let key of Object.keys(realMetaObject)) {
      if (key == 'Photo no') {
        // This has been renamed, check just in case
        fullMetaObject['Photo number'] = realMetaObject[key];
      } else if ((key == 'XXX_related_records') || (key == 'Photo no') || (key == 'Photo url')) {
        // Skip 'related_records', 'Photo url'
        // RJG - why related_records?
        continue;
      } else {
        // Copy metadata for each other key
        fullMetaObject[key] = realMetaObject[key];
        //console.log('RJG - fullMetaObject.' + key + '=' + fullMetaObject[key]);
      }

      // Values may be a ';' separated string, so try to turn them into
      // a real list so we can iterate correctly
      if (!Array.isArray(fullMetaObject[key])) {
        if (String(fullMetaObject[key]).includes(';')) {
          fullMetaObject[key] = String(fullMetaObject[key]).split(/ ?; ?/);
          //console.log(`DEBUG - fullMetaObject[${key}]=${fullMetaObject[key]}`);
        }
      }
    }

    // Return the checked object
    return fullMetaObject;
}

// Search the metadata object for the author
// This MUST be in the correct order as per metadata
// Returns an array of authors
export function getAttributionAuthor(metaObject) {

    // Sanity check...
    if (!metaObject) {
        return metaObject;
    }

    // ------------------------------------------------------------------
    // These are the fields used to create the contributors
    // list in the harvester, so we must check all of them in
    // case there are different values in different fields.
    // ------------------------------------------------------------------
    // Remember to update this list when updating the harvester!
    // ------------------------------------------------------------------
    let dc_field_names = [
        'dc.contributor',
        'dc.contributor.advisor',
        'dc.contributor.arranger',
        'dc.contributor.author',
        'dc.contributor.cartographer',
        'dc.contributor.commissioningbody',
        'dc.contributor.compiler',
        'dc.contributor.composer',
        'dc.contributor.corpauthor',
        'dc.contributor.corpcartographer',
        'dc.contributor.corpcompiler',
        'dc.contributor.corpcomposer',
        'dc.contributor.corpeditor',
        'dc.contributor.corpillustrator',
        'dc.contributor.corplyracist',
        'dc.contributor.corpsurveyor',
        'dc.contributor.editor',
        'dc.contributor.illustrator',
        'dc.contributor.interviewee',
        'dc.contributor.interviewer',
        'dc.contributor.issuingbody',
        'dc.contributor.lyricist',
        'dc.contributor.member',
        'dc.contributor.other',
        'dc.contributor.photographer',
        'dc.contributor.sponsor',
        'dc.contributor.surveyor',
        'dc.contributor.translator',
        'dc.identifier.party',
        'dc.creator'
    ];

    // For each field above, lookup the text name:
    var attrAuthorList = [];
    for (let dc_field_name of dc_field_names) {
        // Then if the field exists in metadata, add to the list
        let field = new_records_mapping_lookup[dc_field_name];
        if (metaObject[field]) {
            //console.log(` -> key:${dc_field_name} value:${field} lookup:${metaObject[field]}`);
            if (Array.isArray(metaObject[field])) {
              //console.log(` -- Array - metaObject[field] = ${metaObject[field]}`);
              for (let F of metaObject[field]) {
                //console.log(` -- Array = ${F}`);
                // Trim any blanks using a regex and add to list
                let trimmedAuthor = String(F).trim().replace(/(^[;\s]+)|([;\s]+$)/g, '').trim();
                if ((trimmedAuthor != '') && (!attrAuthorList.includes(trimmedAuthor))) {
                  attrAuthorList.push(trimmedAuthor);
                }
              }
            } else {
              //console.log(` -- String - metaObject[field] = ${metaObject[field]}`);
              // Trim any blanks using a regex and add to list
              let trimmedAuthor = String(metaObject[field]).trim().replace(/(^[;\s]+)|([;\s]+$)/g, '').trim();
              if ((trimmedAuthor != '') && (!attrAuthorList.includes(trimmedAuthor))) {
                attrAuthorList.push(trimmedAuthor);
              }
            }
        }
    }
    //console.log(`attrAuthorList = '${attrAuthorList}'`);
    return attrAuthorList;
}

// Return String In Title Case
export function titleCase(str) {
 var splitStr = str.toLowerCase().split(' ');
 for (var i = 0; i < splitStr.length; i++) {
   splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
 }
 return splitStr.join(' ');
}

// Return String In Title Case, taking some punctuation into account
// Eg:
//  Kettle, Ellen S. (ellen Sarah)
//  Aboriginal Peoples (australians)
//  Missions (church Settlements)
export function titleCasePlus(str) {
  // $ python3
  // >>> import string
  // >>> string.punctuation
  // '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~'
  const regex = new RegExp(/([^\W_]+[^\s-\.\(\)\[\]\:]*) */, "ig");
  return str.replace(
    regex,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  ).replace(' Nt',' NT').replace('(Nt)','(NT)');
}

// Fix case of things like LANT, PictureNT, etc.
export function fixCase(str) {
  let nt_lookup = {
    "environment": "EnvironmeNT",
    "filmnt": "FilmNT",
    "historynt": "HistoryNT",
    "indexnt": "IndexNT",
    "librarynt": "LibraryNT",
    "librariesnt": "LibrariesNT",
    "mapnt": "MapNT",
    "musicnt": "MusicNT",
    "namasteynt": "NamasteyNT",
    "newspapernt": "NewspaperNT",
    //"parent": "PareNT",
    "parliamentnt": "ParliamentNT",
    "picturent": "PictureNT",
    "publicationnt": "PublicationNT",
    "storynt": "StoryNT"
    //"syntax": "SyNTax",
    //"intune": "iNTune",
    //"jointed": "joiNTed"
  };
  let splitStr = str.split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    // All these ones are just plain capitals
    let lantRegex = new RegExp(/^(aflnt|cogso|lant|lgant|ngint|nt.*|wwii)$/, 'i');
    splitStr[i] = splitStr[i].replace(lantRegex, function(x) { return x.toUpperCase(); });
    if (nt_lookup.hasOwnProperty(splitStr[i].toLowerCase())) {
      splitStr[i] = nt_lookup[splitStr[i].toLowerCase()];
    }
  }
  return splitStr.join(' ');
}

// Check for mobile browser
// From: http://detectmobilebrowsers.com/
export function isMobileBrowser() {
  let isMobile = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return isMobile;
}
